import { ExternalLink } from "lucide-react";

const ZOOPLA_BRANCH_URL =
  "https://www.zoopla.co.uk/find-agents/branch/keystone-properties-batley-166551/";

/**
 * ZooplaBranchButton
 * A branded CTA that sends users to the Keystone Properties branch page on Zoopla.
 *
 * Variants:
 *   - "solid"   : filled Zoopla purple pill (used inline on pages, footer)
 *   - "outline" : outline pill on dark backgrounds (footer / hero contexts)
 *   - "banner"  : full-width banner card (used on Properties page top)
 */
const ZooplaBranchButton = ({
  variant = "solid",
  label = "View all our properties on Zoopla",
  className = "",
  testId = "zoopla-branch-btn",
}) => {
  const base =
    "inline-flex items-center gap-2 font-semibold rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#8046F1]";

  const styles = {
    solid:
      "bg-[#4C2C79] hover:bg-[#3d2361] text-white px-5 py-2.5 text-sm shadow-sm hover:shadow-md",
    outline:
      "bg-white/5 hover:bg-white text-white hover:text-[#4C2C79] border border-white/40 hover:border-white px-5 py-2.5 text-sm",
    banner:
      "bg-[#4C2C79] hover:bg-[#3d2361] text-white px-6 py-3 text-base shadow-md hover:shadow-lg",
  };

  return (
    <a
      href={ZOOPLA_BRANCH_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`${base} ${styles[variant] || styles.solid} ${className}`}
      data-testid={testId}
      aria-label="View all Keystone Properties listings on Zoopla (opens in new tab)"
    >
      <ZooplaMark />
      <span>{label}</span>
      <ExternalLink className="w-4 h-4 opacity-80" aria-hidden="true" />
    </a>
  );
};

/**
 * Compact Zoopla wordmark. Purely visual — avoids external SVG dependency.
 */
const ZooplaMark = () => (
  <span
    className="inline-flex items-center justify-center rounded-md bg-white text-[#4C2C79] px-1.5 py-0.5 text-[10px] font-black tracking-wider leading-none"
    aria-hidden="true"
  >
    Zoopla
  </span>
);

export default ZooplaBranchButton;
